import Vue from "vue";
import "./plugins/vuetify";
import "./plugins/firebaseinit";
import App from "./App.vue";
import router from "./router";
import { store } from "@/store";
import vuetify from "./plugins/vuetify";
import vueMoment from "vue-moment";
import VueMq from "vue-mq";

//console.log("Shims");

Vue.use(VueMq, {
    breakpoints: {
        // default breakpoints - customize this
        mobile: 450,
        tablet: 900,
        laptop: 1250,
        desktop: Infinity,
    },
    defaultBreakpoint: "mobile", // customize this for SSR
});

Vue.config.productionTip = false;

new Vue({
    router,
    store,
    vuetify,
    render: h => h(App),
}).$mount("#app");

Vue.use(vueMoment);
